export default __webpack_public_path__ + "static/media/Coloring.b7569058.svg";